import { RichText } from '@sbercloud/uikit-product-site-rich-text';
import {
  SectionBasic,
  SectionBasicProps,
} from '@sbercloud/uikit-product-site-section';
import { WithLayoutType } from '@sbercloud/uikit-product-utils';
import { ReactNode } from 'react';

import s from './styles.module.scss';
import { getIframeSize } from './utils';

export type SectionMapProps = WithLayoutType<{
  /** Ссылка на карту */
  mapUrl: string;
  /** Содержимое сбоку от карты (поддерживается RichText) */
  children: ReactNode;
  /** Местоположение контента в секции */
  contentPosition: 'left' | 'right';
  /** CSS-класс */
  className?: string;
}> &
  Pick<SectionBasicProps, 'title' | 'titleTag' | 'backgroundColor' | 'id'>;

export function SectionMap({
  layoutType,
  mapUrl,
  contentPosition,
  title,
  titleTag,
  children,
  backgroundColor,
  className,
  id,
}: SectionMapProps) {
  return (
    <SectionBasic
      layoutType={layoutType}
      title={title}
      titleTag={titleTag}
      backgroundColor={backgroundColor}
      className={className}
      id={id}
    >
      <div className={s.wrapper} data-layout-type={layoutType}>
        <div
          className={s.sectionContent}
          data-layout-type={layoutType}
          data-content-position={contentPosition}
        >
          <iframe
            src={mapUrl}
            className={s.mapIframe}
            data-layout-type={layoutType}
            {...getIframeSize(layoutType)}
          />
          <div className={s.content}>
            {typeof children === 'string' ? (
              <RichText richText={children} />
            ) : (
              children
            )}
          </div>
        </div>
      </div>
    </SectionBasic>
  );
}
